// Import Shared
import FieldMask from '@shared-modifiers/FieldMask/FieldMask';

// import css before other files to preserve ordering
import './bundle.projectGeisinger.css';

// import component js
import BenefitsSlider from './elements/modifiers/benefitsSlider/benefitsSlider';
import Tabs from './elements/modifiers/tabs/tabs';

function componentSetup() {
  const elInputs = document.querySelectorAll('.js-input');
  BenefitsSlider();
  Tabs();
  elInputs.forEach((input) => FieldMask({ el: input }));
}

document.addEventListener('DOMContentLoaded', componentSetup);
